import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const ARStyrvardeMeny: IRutinInfo[] = [
  rutinInfos.rtnHuvudRubrik,
  rutinInfos.rtnRubrik,
  rutinInfos.rtnAnlGrupp,
  rutinInfos.rtnOmrade,
  rutinInfos.rtnAnlKat,
  rutinInfos.rtnVerksamhetskod,
  rutinInfos.rtnAtgardskod,
  rutinInfos.rtnKomponent,
  rutinInfos.rtnRanteTabell,
  rutinInfos.rtnInventeringsansvarig,
  rutinInfos.rtnFordelningsmall,
];

export default ARStyrvardeMeny;
